<p-fileUpload name="file[]" [url]="fileUploadUrl" auto="auto" (onUpload)="onUpload($event)" (onBeforeUpload)="onBeforeUpload()"
  (onBeforeSend)="onBeforeSend($event)" (onSelect)="onSelect($event)" (onError)="onUploadError($event)" ngDefaultControl [accept]="accept"
  [chooseLabel]="uploadButtonLabel" [maxFileSize]="maxSize" [withCredentials]="true"
  [invalidFileSizeMessageSummary]="maxSizeMessage" [invalidFileTypeMessageSummary]='invalidFileMessage'>
</p-fileUpload>
